<template>
  <li  
    :id="slug"
    class="project"
    :class="{ 
      hidden: hidden,
      faded: faded,
      selected: selected ,
      fadein: fadein,
    }"
  >
    <a 
      class="name"
      :class="{ 
        hovered: hovered,
      }"
      @mouseover="hoverinProject"
      @mouseleave="hoveroutProject"
      @click="clickProject"
    >
      <span class="bullet" v-if="selected">✕</span>
      <span class="bullet" v-else>⤷</span>
      <span class="value"> {{ title }} </span>
      <span class="date"> {{ date }} </span>
    </a> 
    <div class="body"> 
      <vue-markdown 
        v-if="selected"
        :source="body"
      />
      <vue-markdown 
        v-if="selected && role"
        :source="role"
        class="role"
      />
    </div>
  </li>
</template>

<script>
import moment from 'moment'

export default {
  name: "Project",
  props: [
    'slug',
    'title',
    'StartDate',
    'EndDate',
    'body',
    'role',
    'relationship',
    'collaborators'
  ],
  data() {
    return {
      date: 'Ongoing',
      hovered: false,
      hidden: false,
      faded: false,
      selected: false,
      fadein: false,
      relatedCollaborators: [],
      moment: moment,
    }
  },
  created() {
  },
  mounted() {
    this.getDate()

    const allCollaborators = this.$parent.$refs.collaborators
    this.collaborators.forEach((collaborator) => {
      const relatedCollaborator = allCollaborators.find(c => c.slug === collaborator.slug)
      this.relatedCollaborators.push(relatedCollaborator)
    })
    this.relatedCollaborators.sort((a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 
            : (textA > textB) ? 1 
            : 0
    })
  },
  methods: { 
    getDate() {
      if (this.EndDate) {
        const StartDate = parseFloat(moment(this.StartDate).format('YYYY'))
        const EndDate = parseFloat(moment(this.EndDate).format('YYYY'))
        if (StartDate == EndDate) {
          this.date = EndDate
        } else {
          this.date = StartDate + ' – ' + EndDate
        }
      }
    },
    hoverinProject () { this.$emit('projectHovered', this) },
    hoveroutProject () { this.$emit('projectUnhovered', this) },
    clickProject () { this.$emit('projectClicked', this) },
  },
}
</script>

<style scoped>
.project {
}
.project .content {
  overflow: auto;
}
.project .role {
  border: var(--thin-grey);
  padding: 10px;
}
.project .role :first-child {
  margin-top: 0;
}
.project .role :last-child {
  margin-bottom: 0;
}
.project a.name span.bullet {
  transition: margin 0.2s ease;
}
.project a.name span.value {
  transition: font-size 0.2s ease, padding 0.2s ease;
}
.project a.name span.date {
  transition: margin 0.2s ease;
}

.project.selected.fadein a.name {
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  padding-bottom: 10px;
  background: var(--palest-yellow);
  border-bottom: var(--thin-grey);
}
.project.selected a.name span.bullet {
  margin-top: 8px;
  transition: margin 0.2s ease;
}
.project.selected a.name span.value {
  padding-left: 5px;
  font-size: 18pt;
  font-weight: normal;
  font-family: 'Almendra';
  transition: font-size 0.2s ease, padding 0.2s ease;
}
.project.selected a.name span.date,
.project.selected.fadein a.name span.date {
  margin-top: 6px;
  opacity: 1;
  transition: margin 0.2s ease;
}
.project.selected.fadein .body {
  padding-bottom: 20px;
}
.project.selected.fadein a.name span.bullet {
  margin-top: 8px;
}
</style>